<template>
    <c-mobile-menu class="mobile-menu-container">
    <div class="mobile-menu-wrapper">

        <span class="mobile-menu-close"><i class="icon-cancel"></i></span>

        <nav class="mobile-nav">
            <ul class="mobile-menu">
                <li class="active">
                    <a :href="routeHome">Início</a>
                </li>
                <li v-if="client && company.finalizacao_pagamento.tipo != 'ORCAMENTO'">
                    <a :href="routeMyAccount">Minha Conta</a>
                    <ul class="links">
                        <li><a :href="routeMyAccount">Minha Conta</a></li>
                        <li><a :href="routeWishlist">Minha lista de desejos</a></li>
                        <li><a :href="routePurchases">Meus {{ isBudgetLayout ? 'Orçamentos' : 'Pedidos' }}</a></li>
                    </ul>
                </li>
                <li v-else-if="!client && company.finalizacao_pagamento.tipo != 'ORCAMENTO'">
                    <a :href="routeLogin">Entre ou cadastre-se</a>
                </li>

                <slot name="categorias"></slot>

                <li
                    v-if="client && company.finalizacao_pagamento.tipo != 'ORCAMENTO'"
                >
                    <a @click.prevent="logout()" href="#">Sair</a>
                </li>
            </ul>
        </nav>

        <div class="social-icons">
            <template v-if="company.socials">

                <a
                    v-if="company.socials[0].link"
                    :href="company.socials[0].link"
                    class="social-icon"
                    target="_blank"
                >
                    <i class="icon-facebook" title="siga-nos Facebook"></i>
                </a>

                <a
                    v-if="company.socials[3].link"
                    :href="company.socials[3].link"
                    class="social-icon"
                    target="_blank"
                >
                    <i class="icon-twitter" title="siga-nos Twitter"></i>
                </a>

                <a
                    v-if="company.socials[1].link"
                    :href="company.socials[1].link"
                    class="social-icon"
                    target="_blank"
                >
                    <i class="icon-instagram" title="siga-nos Instagram"></i>
                </a>

            </template>
        </div>
    </div>
</c-mobile-menu>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {CMobileMenu} from '../Styles/MobileMenu/styled'

export default {
    name: 'MenuMobile',
    props: {
        clientLogged: {
            default:null,
            type: Object
        },
        company: {
            required:true,
            type: Object
        },
        routeLogin: {
            required: true,
            type: String
        },
        routeLogout: {
            required: true,
            type: String
        },
        routeHome: {
            required: true,
            type: String
        },
        routeMyAccount: {
            required: true,
            type: String
        },
        routeWishlist: {
            required: true,
            type: String
        },
        routePurchases: {
            required: true,
            type: String
        },
    },
    components: {
        'c-mobile-menu': CMobileMenu
    },
    created() {
        this.ActionSetCompany(this.company)
        if (!this.clientLogged.data) {
            return
        }
        this.ActionSetClient(this.clientLogged.data)
    },
    mounted() {
        let menu = document.querySelectorAll(".mobile-menu li")
        menu.forEach(el => {
            let child = el.lastChild
            if(child.localName == "ul") {
                el.firstChild.style.borderRight = "1px solid rgba(255, 255, 255, 0.2)"
            }
        })
    },
    methods: {
        ...mapActions("company", [
            "ActionSetCompany"
        ]),
        ...mapActions("clients", [
            "ActionSetClient",
            "ActionLogout"
        ]),
        async logout() {
            await this.ActionLogout()
            .then(response => {})
            .catch(error => {})
            window.location.href = this.$baseUrl
        }
    },
    computed: {
        ...mapState("clients", [
            "client"
        ]),
        isBudgetLayout() {
            return this.$root.$children[0].theme?.is_budget_layout ?? false
        },
    }
}
</script>
